import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

import { fetchProfileData, fetchProviderSchedule } from "../Store/Actions";
import {
  Case,
  Default,
  Switch,
} from "../components/common/ConditionalRendering";
import Loader from "../components/common/Loader";

const ProfilePreviewRoute = () => {
  const dispatch = useDispatch();
  const user = useSelector(state => state?.auth?.user);
  const providerProfileLoading = useSelector(
    state => state?.provider?.providerProfileLoading
  );

  useEffect(() => {
    if (user) {
      dispatch(fetchProfileData(true));
      dispatch(fetchProviderSchedule());
    }
  }, [user]);

  return (
    <Switch>
      <Case condition={!user}>
        <Navigate to="/login" replace />
      </Case>

      <Case condition={providerProfileLoading}>
        <Loader wrapperHeight="100vh" />
      </Case>

      <Default>
        <Outlet />
      </Default>
    </Switch>
  );
};

export default ProfilePreviewRoute;
